'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalogDetail = require('./remote/catalogDetail');

var CatalogDetail = {
    fetchCatalogDetailsByIds: _catalogDetail.CatalogDetailRemote.fetchCatalogDetailsByIds
};

exports.default = CatalogDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/catalogDetail.js
// module id = Kt20
// module chunks = 60